<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">帮助中心</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="7" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="title_box fs18 col04 fwb">新手指南-安全采购</div>
                <template v-if="helpList.length > 0">
                    <div class="item flex-box mb15 cursor" v-for="(item, index) in helpList" :key="index"
                        @click="toDetail(item.id, index + 1)">
                        <div class="index fs16 col12">Q{{ index + 1 + ((page - 1) * 10)}}</div>
                        <div class="flex-grow-1 fs16 col12 m-ellipsis">{{ item.name }}</div>
                    </div>
                </template>
                <pagination :sumCount="sumCount" :perCount="perCount" @pageTurn="pageTurn" v-show="sumCount > perCount">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "帮助中心-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            helpList: [],
            page: 1,
            sumCount: 0,
            perCount: 10,
        };
    },
    created() {
        this.getHelps();
    },
    methods: {
        toDetail(id, index) {
            console.log(id)
            this.$router.push({ path: '/HelpDetail', query: { id, index } });
        },
        getHelps() {
            this.$api.getHelper({
                id: 1,
                page: this.page,
            }).then(res => {
                this.helpList = res.data.data;
                this.sumCount = res.data.total;
                this.perCount = res.data.per_page;
            })
        },
        // 翻页
        pageTurn(i) {
            this.page = i + 1;
            this.getHelps();
        },
    },
};
</script>

<style lang="less" scoped>
.part_r {
    padding: 0 44px 44px;
    background-color: #fff;

    .title_box {
        padding: 41px 0 32px;
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);
        margin-bottom: 24px;
    }

    .item {
        height: 68px;
        background: #F7FAFF;
        padding: 0 44px 0 24px;

        .index {
            width: 44px;
            height: 44px;
            background: #FFFFFF;
            text-align: center;
            line-height: 44px;
            border-radius: 50%;
            margin-right: 15px;
        }

        &::after {
            content: "";
            display: block;
            width: 18px;
            height: 18px;
            background: url('../../../assets/static/icon/c_service_right.png') no-repeat center;
            background-size: 100%;
            margin-left: auto;
        }
    }
}
</style>
